import { useState } from 'react';
import { faqItems } from '@/mocks/homeData';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggleFAQ = (idx: number) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  return (
    <section className="py-20 md:py-28 bg-background-100">
      <div className="px-4 md:px-6 max-w-3xl mx-auto">
        <div className="text-center mb-12">
          <p className="text-sm font-semibold text-primary-500 uppercase tracking-wider mb-3">FAQ</p>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-4">
            Frequently Asked Questions About VigorBuy Spreadsheet
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            Find answers to the most common questions about VigorBuy Spreadsheet. 
            Can&apos;t find what you need? Explore our complete guide for more details.
          </p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item, idx) => (
            <div
              key={idx}
              className="rounded-xl bg-background-50 border border-background-200/60 overflow-hidden"
            >
              <button
                onClick={() => toggleFAQ(idx)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-100/50 transition-colors"
              >
                <span className="text-sm md:text-base font-semibold text-foreground-800 pr-4">
                  {item.question}
                </span>
                <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 rounded-full transition-all duration-300 ${
                  openIndex === idx ? 'bg-primary-100 rotate-180' : 'bg-background-200'
                }`}>
                  <i className={`text-xs transition-colors ${
                    openIndex === idx ? 'text-primary-500 ri-subtract-line' : 'text-foreground-500 ri-add-line'
                  }`}></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === idx ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                  {item.answer}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}